module.exports = __webpack_public_path__ + "img/ar.7aa64bc4.svg";